import { fromJS } from 'immutable';
import { ADD_SELECTION, CLEAR_SELECTION, SHOW_CONFIRM_DELETE_MODAL, SHOW_COMMENT_DELETE_CONFIRMATION, CLEAR_STAGE_SELECTIONS, SHOW_TEMPLATE_MODAL, ADD_ACTIVE_PLUGIN_ID } from './constants';
import { STAGE_SELECTION_SCOPE } from '@pearsontechnology/aero-stage-presentation-framework/dist/rce/constants';

const initialState = fromJS({
  selections: [],
  showConfirmDeleteModal: false,
  commentDeleteConfirmation: {
    showModal: false,
    comment : {
      environment: null,
      annotationId: null,
      elementId: null,
      elementType: null,
    },
  },
  templateModal: {showModal: false, templateSelectionCallback: null},
  pluginId: null,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SELECTION: {
      if (Array.isArray(action.selection)) {
        return state.updateIn(['selections'], (arr) =>
          arr.push(...action.selection)
        );
      } else {
        return state.updateIn(['selections'], (arr) =>
          arr.push(action.selection)
        );
      }
    }
    case CLEAR_STAGE_SELECTIONS: {
      return state.updateIn(['selections'], (arr) => (arr.filter((selection) => !(selection.path.includes(...STAGE_SELECTION_SCOPE))))
      );
    }
    case CLEAR_SELECTION: {
      if (action.scope[0].path) {
        return state.updateIn(['selections'], (arr) =>
          arr.filter((selection) =>
            action.scope.some(
              (ns) => ns.path.join('.') !== selection.path.join(".")
            )
          )
        );
      } else {
        return state.updateIn(['selections'], (arr) =>
          arr.filter(
            (selection) => selection.path.join('.') !== action.scope.join('.')
          )
        );
      }
    }
    case SHOW_CONFIRM_DELETE_MODAL: {
      //TODO: Not sure if this is workings, returns undefined when i try to use it
      return state.set('showConfirmDeleteModal', action.showModal);
    }

    case SHOW_COMMENT_DELETE_CONFIRMATION : {
      return state.set('commentDeleteConfirmation', {showModal: action.showModal, comment: action.comment});
    }

    case SHOW_TEMPLATE_MODAL : {
      return state.set('templateModal', {showModal: action.showModal, ...(action.showModal ? {templateSelectionCallback: action.templateDetail.templateSelectionCallback} : {templateSelectionCallback: null})});
    }

    case ADD_ACTIVE_PLUGIN_ID: {
      return state.set('pluginId', action.pluginId);
    }
      
    default:
      return state;
  }
};

export default reducer;
